import { VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

type FormProps = {
  onSubmit: () => void;
};

export const Form: React.FC<PropsWithChildren<FormProps>> = ({ children, onSubmit }) => {
  return (
    <form onSubmit={onSubmit} style={{ width: '100%' }}>
      <VStack gap="20px" width="100%">
        {children}
      </VStack>
    </form>
  );
};
